import { css } from 'linaria';

export const infoBar = css`
  margin-top: var(--space-400);
  margin-bottom: 0;
  background-color: var(--attention-light) !important;
  box-shadow: none !important;
`;
